import * as React from "react";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function LinearProgressWithLabel(
  props: LinearProgressProps & {
    value: number;
    color1: string;
    color2: string;
    value_real: number;
  }
) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress
          variant="determinate"
          {...props}
          style={{ backgroundColor: props.color2 }}
          sx={{
            "& .MuiLinearProgress-bar1Determinate": {
              backgroundColor: props.color1,
            },
          }}
        />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="green">{`${Math.round(
          props.value_real
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

export default function LinearWithValueLabel(props: {
  value: number;
  color1: string;
  color2: string;
  width?: string;
}) {
  let value: number = props.value;
  if (props.value > 100) {
    value = 100;
  }
  let width: string = "100%";
  if (props.width) {
    width = props.width;
  }
  return (
    <Box sx={{ width: width }}>
      <LinearProgressWithLabel
        value_real={props.value}
        value={value}
        color1={props.color1}
        color2={props.color2}
      />
    </Box>
  );
}
